import React from "react";
import { Fade } from "react-awesome-reveal";

const Info = ({ heading, content }) => {
  const shoeName = (
    <div className="shoeName">
      <h1 className="big">{heading}</h1>
    </div>
  );

  const description = (
    <div className="description">
      <Fade cascade>
        <p className="text">
          {content}
        </p>
      </Fade>
    </div>
  );

  return (
    <div className="info">
      {shoeName}
      {description}
    </div>
  );
};

export default Info;
